"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
const _1 = require(".");
function default_1() {
    const [showCategorySelectDialog, setShowCategorySelectDialog] = (0, react_1.useState)(false);
    const openCategorySelectDialog = () => setShowCategorySelectDialog(true);
    const closeCategorySelectDialog = () => setShowCategorySelectDialog(false);
    const category = (0, react_redux_1.useSelector)((state) => state.roomData.category);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(wrapper_component_1.UpperSectionContentWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "required_wrapper subtitle2" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "gray-80" }, { children: t('무엇을 판매하시나요?') })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "error-main" }, { children: "*" }))] })), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ onClick: openCategorySelectDialog, sx: {
                            width: '100%',
                            justifyContent: 'space-between',
                            columnGap: '12px',
                            height: '48px',
                            padding: '0 14px',
                            borderRadius: '8px',
                            border: '1px solid var(--gray-10)',
                            color: 'var(--gray-80)',
                            bgcolor: 'var(--white) !important',
                        } }, { children: [!!category ? ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: category.name }))) : ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-40" }, { children: t('선택해 주세요') }))), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: { width: '20px', height: '20px' } })] }))] }), (0, jsx_runtime_1.jsx)(_1.CategorySelectDialog, { open: showCategorySelectDialog, closeDialog: closeCategorySelectDialog })] }));
}
exports.default = default_1;
